import { createFileRoute } from '@tanstack/react-router';

import { automaticPixListSearch, bankAccountAutomaticPixActiveScreen, loadBankAccountMessages, loadBankAccountScreens } from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

// Autorizações ativas do Pix Automático (`router.tsx:543-548`).
export const Route = createFileRoute('/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas')({
  validateSearch: automaticPixListSearch,
  staticData: { screen: bankAccountAutomaticPixActiveScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountAutomaticPixActiveScreen'),
});
